import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  tryToGetMemberships,
  // tryToGetOrganizationMembersLog
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Transfer organization ownership
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestTransferOrganizationOwnership = packet => {
  return {
    type: 'REQUEST_TRANSFER_ORGANIZATION_OWNERSHIP',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveTransferOrganizationOwnershipSuccess = data => ({
  type: 'RECEIVE_TRANSFER_ORGANIZATION_OWNERSHIP_SUCCESS',
  data
})

export const receiveTransferOrganizationOwnershipFail = data => ({
  type: 'RECEIVE_TRANSFER_ORGANIZATION_OWNERSHIP_FAIL',
  data
})

export const tryToTransferOrganizationOwnership = packet => (dispatch, getState) => {

  dispatch(requestTransferOrganizationOwnership(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/organizations/transfer/' + packet.id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveTransferOrganizationOwnershipSuccess(json));
      dispatch(tryToGetMemberships());
      dispatch(push('/workbench/' + packet.id + '/settings/members'));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveTransferOrganizationOwnershipFail({errors:e, lastSubmit: packet}));
    })
}
